import { isArray, get } from "lodash"
import { Requests } from "./Requests"
import endpoints from '../../endpoints'

const WEB_APP_BASE_URL = endpoints.WEB_APP

export default class PermissionsHelper {

  static async getOrgPermissions(org){
    let encodedOrg = encodeURIComponent(org)
    const url = `${WEB_APP_BASE_URL}/api/toolkit/orgs/${encodedOrg}/permissions`
    let res = await Requests.authRequest(url, 'GET')
    return res
  }

  static async updateOrgPermissions(org, permissions, changes){
    const url = `${WEB_APP_BASE_URL}/api/toolkit/orgs/permissions`
    try {
      await Requests.authRequest(url, 'PUT', { ...permissions, orgName: org, changes }, true)
    } catch (error) {
      console.error('Error updating org permissions', error)
      throw error
    }
  }

  static async getRolePermissions(org){
    const encodedOrg = encodeURIComponent(org)
    const url = `${WEB_APP_BASE_URL}/api/toolkit/orgs/${encodedOrg}/roles/permissions`
    let res = await Requests.authRequest(url, 'GET')
    if (!res || !isArray(res)) return []
    const rolePermissions = res.map( roleObj => {
      return {
        role: roleObj.groupName,
        permissions: roleObj.groupPermissionList,
        orgName: roleObj.organizationId
      }
    })
    return {rolePermissions}
  }

  static async updateRolePermissions(org, role, permissions){
    const url = `${WEB_APP_BASE_URL}/api/toolkit/orgs/roles/permissions`
    try {
      await Requests.authRequest(url, 'PUT', { ...permissions, roleName: role, orgName: org }, true)
    } catch (error) {
      console.error('Error updating role permissions', error)
      throw error
    }
  }

  static async getUserPermissions(org, userId){
    const encodedOrg = encodeURIComponent(org)
    const url = `${WEB_APP_BASE_URL}/api/toolkit/orgs/${encodedOrg}/users/${userId}/permissions`
    let res = await Requests.authRequest(url, 'GET')
    if (!res || !isArray(res)) return []
    return res
  }

  static async getSystemPermissions(){
    const url = `${WEB_APP_BASE_URL}/api/toolkit/system-permissions`
    let res = await Requests.authRequest(url, 'GET')
    if (!res || !isArray(res)) return []
    return res
  }

  static sortItems = (order, property) => (a, b) => {
    const itemA = get(a, property)
    const itemB = get(b, property)
    if(order === 'asc'){
      return itemA < itemB ? -1 : 1
    } else {
      return itemA < itemB ? 1 : -1
    }
  }
  static filterPermissions = (Items, filter) => {
    filter = filter.toLowerCase();
    if(!filter) return Items
    if(Items && Items.length > 0){
      const filteredItems = Items.filter((item) => item.description?.toLowerCase().includes(filter) || item.permission?.toLowerCase().includes(filter))
      return filteredItems
    }
  }
  
}